module.exports = __webpack_public_path__ + "static/img/error.fba26098.png";